import ClassNameExtendableHoC from 'components/HoC/ClassNameExtendableHoC';

const MainBox = ClassNameExtendableHoC('div', 'ds-list__content-empty');

export { MainBox };
